<template>
    <div class="product">
        <div v-if="state != selectedState" class="d-flex justify-content-center">
            <div class="loader"></div>
        </div>
        <div v-else>
            <div v-if="(publications && publications.length) || (product && product.burrito)" class="row">

                <!-- LEFT SIDE -->
                <div class="col-lg-5">
                    <!-- primary thumbnail -->
                    <div class="row">
                        <!-- DEBUG -->
                        <div style="display: none">{{product}}</div>
                        <!-- PRODUCT COVER -->
                        <ProductCover :product="product"/>

                    </div>
                    <div class="row">
                        <!-- Carousel -->
                        <ProductResources :product="product" :publications="publications" />
                    </div>
                </div>

                <!-- RIGHT SIDE -->
                <div class="col-lg-7 order-lg-2 order-3 align-self-stretch mt-lg-0 mt-3">
                    <div ref="productDetails" class="card">

                        <h3 class="card-header text-capitalize" style="white-space: nowrap">
                            <template v-if="product.state && product.topic != 'National Social Studies'">
                                {{formattedState}}
                            </template>
                            <template v-if="product.topic && product.topic != 'National Social Studies'">
                                {{formattedTopic}}
                            </template>
                            <template v-if="product.topic == 'National Social Studies'">
                                <strong>NEW</strong> Social Studies
                            </template>
                            <template v-else >
                                {{product.name}}
                                <small v-if="showSku" style="opacity: 0.03">{{product.sku}}</small>
                            </template>
                        </h3>

                        <div class="card-body border-bottom">
                            <div class="h3 m-0">
                                <span v-if="product.price">
                                    {{product.price | currency}}
                                </span>

                                <span v-else>
                                    <div class="d-flex align-items-center">
                                        <div>
                                            <div class="mb-2">
                                                <span style="color:red;text-decoration:line-through;margin-right:10px;" v-if="false && product.state && (product.topic == 'Well Being' || product.topic == 'Well-Being') && quantity > 9">
                                                    <span style="color:black;">{{8.15 * multiyear_selected.value | currency}}</span>
                                                </span>{{price_multiyear | currency}}<small>/ {{multiyear.value}} Year <span v-if="isHomeschoolStore">Homeschool</span> Subscription</small>
                                                <b-alert variant="danger" size="sm" :show="showNYPromo" class="" style="font-size: 18px">
                                                    Order NOW, Pay in 90 Days!
                                                </b-alert>
                                            </div>
                                        </div>
                                        <div class="ml-auto text-right">
                                            <div class="text-muted" style="font-size: 12px;">
                                                <div class="text-nowrap">{{ multiyear_selected.value }} Year Pricing</div>
                                                <div class="text-nowrap"><span style="color:red;text-decoration:line-through;margin-right:5px;" v-if="product.state && product.topic == 'Well Being' && quantity > 9"><span style="color:#6c757d;">{{7.95 | currency}}</span></span>{{ price_single | currency}}<small>/each year</small></div>
                                            </div>
                                        </div>
                                    </div>
                                </span>
                                <div v-else-if="productDescription" class="mt-3" style="font-size: .5em">
                                    <p>{{productDescription}}</p>
                                </div>
                                <!--                             <div class='my-0' v-if="product.state && product.topic == 'Well Being'">
                                                                <small style='font-size: .5em; line-height: .3em' class='text-success'>
                                                                    Buy well-being now for the <b>introductory price</b> of $6.95 per student. Min qty 10.
                                                                </small>
                                                            </div>
                                                            <div class='my-0' v-if="product.state && product.topic == 'Well Being'">
                                                                <small style='font-size: .5em; line-height: .3em' class='text-danger'>
                                                                    Offer valid through Dec. 31st, 2020.
                                                                </small>
                                                            </div> -->
                            </div>
                        </div>
                        <div class="card-body">

                            <h5 v-if="product && product.state" class="d-lg-block d-none">
                                {{product.title}}
                            </h5>

                            <div  v-if="product && product.sku && (product.sku.startsWith('CA-07-SS') || product.sku.startsWith('CA-08-SS'))" class="text-danger" >
                                Not state adopted
                            </div>
                            <form class="product-form" @submit.prevent>
                                <div class="row">

                                    <div v-if="product.product_group" class="col-lg-12">
                                        <div class="form-group">
                                            <label for="product_group">Product</label>
                                            <ul class="nav nav-pills">
                                                <li v-for="(altProduct, name) in groupedProducts" :key="altProduct.product_group_handle" class="nav-item">
                                                    <router-link
                                                        class="nav-link grade"
                                                        :class="{
                                                            'kindergarten': name == 0,
                                                            'first-grade': name == 1,
                                                            'second-grade': name == 2,
                                                            'third-grade': name == 3,
                                                            'fourth-grade': name == 4,
                                                            'fifth-grade': name == 5,
                                                            'sixth-grade': name == 6,
                                                            'seventh-grade': name == 7,
                                                            'eighth-grade': name == 8,
                                                            'active': altProduct.id == product.id
                                                        }"
                                                        :to="{name: $route.name, params: {sku: altProduct.sku}}"
                                                    >
                                                        {{altProduct.product_group_handle}}
                                                    </router-link>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>


                                    <!-- GRADE DISPLAY-->
                                    <div v-if="publications && publications.length" class="col-lg-12">
                                        <div class="form-group">
                                            <div  v-if="product.state == 'MO' && (product.grade == 3 || product.grade == 4)" class="alert alert-info" role="alert">
                                                Because state standards now require Missouri History in grade 3, Studies Weekly has aligned its curriculum accordingly.
                                            </div>
                                            <label for="grade">Grade:</label>
                                            <ul class="nav nav-pills">
                                                <li v-for="publication in publications" :key="publication.grade" class="nav-item" @click="resetProductBundlePopup">
                                                    <router-link
                                                        class="nav-link grade"
                                                        :class="{
                                                            'pre-k': publication.grade == -1,
                                                            'kindergarten': publication.grade == 0,
                                                            'first-grade': publication.grade == 1,
                                                            'second-grade': publication.grade == 2,
                                                            'third-grade': publication.grade == 3,
                                                            'fourth-grade': publication.grade == 4,
                                                            'fifth-grade': publication.grade == 5,
                                                            'sixth-grade': publication.grade == 6,
                                                            'seventh-grade': publication.grade == 7,
                                                            'eighth-grade': publication.grade == 8,
                                                            'active': publication.grade == product.grade,
                                                        }"
                                                        :to="{name: subject, params: {state: selectedState, grade: publication.grade, language: publication.language}}"
                                                    >
                                                        <template v-if="publication.grade == -1">
                                                            <span v-if="state == 'CA'">TK</span>
                                                            <span v-else>PK</span>
                                                        </template>
                                                        <template v-else-if="publication.grade == 0">
                                                            K
                                                        </template>

                                                        <template v-else>
                                                            {{publication.grade}}
                                                        </template>
                                                    </router-link>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                    <!-- SAMPLE VERSIONS -->
                                    <div v-if="freeVersion" class="col-lg-12">
                                        <div class="form-group">
                                            <label for="version">Version</label>
                                            <select
                                                class="form-control"

                                                v-model="selectedVersion"
                                            >
                                                <option value="free">Free Version</option>
                                                <option value="full">Full Version</option>
                                            </select>
                                        </div>
                                    </div>

                                    <!-- MULTI-YEAR OPTION (removed) -->

                                    <!-- FORMAT -->
                                    <div v-if="product_formats && product_formats.length && !product.burrito && !freeVersion" class="col-lg-12">
                                        <div class="form-group">
                                            <label for="format">
                                                Format
                                            </label>
                                            <select
                                                class="form-control"

                                                v-model="format"
                                            >
                                                <option v-for="(format, index) in product_formats" :key="index" :value="format.value">
                                                    {{format.label}}
                                                </option>
                                            </select>

                                            <div v-if="product.discontinued == 1" class="mt-2 text-warning">
                                                <small>This product has been discontinued and available online only.</small>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- LANGUAGE -->
                                    <div v-if="languages && languages.length > 1" class="col-lg-12">
                                        <div class="form-group">
                                            <label for="language">Language</label>
                                            <multiselect
                                                v-model="lang"
                                                name="language"
                                                select-label=""
                                                deselect-label=""
                                                :options="languages"

                                                @select="changeLanguage($event)"

                                                :allow-empty="false"
                                            >
                                                <template slot="option" slot-scope="{option}">
                                                    <div class="option__desc d-flex">
                                                        <span v-if="option == 'en'">
                                                            <!-- <span class="flag-icon flag-icon-us mx-1"></span> --> English
                                                        </span>
                                                        <span v-if="option == 'es'">
                                                            <!-- <span class="flag-icon flag-icon-es mx-1"></span> --> Spanish
                                                        </span>
                                                    </div>
                                                </template>
                                                <template slot="singleLabel" slot-scope="props">
                                                    <span class="option__desc">
                                                        <span class="option__title">
                                                            <span v-if="props.option == 'en'">
                                                                <!-- <span class="flag-icon flag-icon-us mx-1"></span> --> English
                                                            </span>
                                                            <span v-if="props.option == 'es'">
                                                                <!-- <span class="flag-icon flag-icon-es mx-1"></span> --> Spanish
                                                            </span>
                                                        </span>
                                                    </span>
                                                </template>
                                            </multiselect>
                                        </div>
                                    </div>

                                    <!-- QUANTITY -->
                                    <div class="col-lg-12">
                                        <div class="form-group mb-0">
                                            <label for="quantity">
                                                Quantity
                                            </label>
                                            <number-input v-model="quantity" :min="minQuantity" :max="1000" controls></number-input>
                                            <!--                                        <div v-if="format == 'online_only' && quantity < 10" class="mt-2 text-warning">-->
                                            <!--                                            <small>Must purchase a minimum of 10 for online only.</small>-->
                                            <!--                                        </div>-->

                                            <div v-if="false && (product.topic == 'Well Being' || product.topic == 'Well-Being') && quantity < 10 && selectedVersion == 'full'" class="mt-2 text-warning">
                                                <small>Must purchase a minimum of 10 for Full Version of Well-Being product.</small>
                                            </div>

                                            <div v-if="limitQuantityForMultiyear" class="mt-2 text-warning">
                                                <small>Must purchase a minimum of 10 for multiple year orders.</small>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-if="product.sku == 'JTMKIT'" class="col-lg-12">
                                        <div class="form-group mb-0">
                                            <div class="mt-2 text-info">
                                                <small>*Recommended for Grades 6 and up.</small>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- NUMBER OF TEACHERS -->
                                    <div v-if="publications && publications.length && !isHomeschoolStore" class="col-lg-12">
                                        <div class="form-group mb-0 mt-3">
                                            <label for="teachers">
                                                Number of Teachers
                                            </label>
                                            <select
                                                class="form-control"

                                                v-model="teachers"
                                            >
                                                <option v-for="option in teacherOptions">{{option}}</option>
                                            </select>
                                        </div>
                                    </div>

                                </div>
                            </form>
                        </div>


                        <div class="card-footer d-lg-block d-none">

                            <div class="d-flex">

                                <button
                                    type="button"

                                    class="btn btn-success text-nowrap"

                                    @click.prevent="addProductToCart"

                                    :disabled="addingProductToCart || productWithDifferentFormatAlreadyInCart || allowAddToCart==false || productWithNoPrice"
                                >
                                    <template v-if="addingProductToCart">
                                        <font-awesome-icon :icon="['far', 'check']" /> Added
                                    </template>
                                    <template v-else>
                                        <font-awesome-icon :icon="['far', 'plus']" /> Add to Cart
                                    </template>
                                </button>
                                <b-btn variant="success" class="ml-2" @click="buyNow">Buy Now</b-btn>

                                <div v-if="product.burrito" class="ml-auto text-right" style="margin-top:10px;padding-left:10px;"> <b>Product Total:</b> {{product.price * quantity | currency}}</div>

                                <div v-if="!product.burrito" class="ml-auto text-right" style="margin-top:10px;padding-left:10px;"> <b>Product Total:</b> {{price_multiyear * quantity | currency}}</div>

                            </div>

                            <div v-if="productWithDifferentFormatAlreadyInCart" class="mt-2">
                                <small class="text-danger">
                                    This product is already in your cart with a different format. Please first remove the conflicting item from the cart, or add more of the same format.
                                </small>
                            </div>

                            <b-modal
                                id="bundle-product-modal"
                                modal-class="bundle-discount-modal"
                                hide-header
                                hide-footer
                                centered
                            >

                                <a
                                    href="#"
                                    class="modal-close"
                                    aria-label="Close"
                                    @click.prevent="setProductBundleDismissed"
                                >
                                    <font-awesome-layers>
                                        <font-awesome-icon icon="circle" class="background" transform="shrink-1" />
                                        <font-awesome-icon :icon="['fas', 'times-circle']" class="foreground" />
                                    </font-awesome-layers>
                                </a>

                                <div class="d-sm-flex align-items-center">
                                    <div class="image-container">
                                        <span>
                                            <img src="//cdn.studiesweekly.com/store/science-bg.png" class="image background-image" width="100%" height="auto">
                                            <img v-if="subject == 'social-studies'" src="//cdn.studiesweekly.com/store/ms-johnson_pointing.png" class="image character-image" width="100%" height="auto">
                                            <img v-if="subject == 'science'" src="//cdn.studiesweekly.com/store/natalia_showing.png" class="image character-image" width="100%" height="auto">
                                        </span>
                                    </div>
                                    <div class="text flex-grow-1">
                                        <div class="h5 mb-3 ml-3">
                                            <span class="font-weight-bold">{{product.title}}</span> was added to the cart.
                                        </div>

                                        <p class="mb-3 ml-3">
                                            Customers who bought this product also bought {{suggestedSubjectName}}.
                                        </p>

                                        <div class="d-flex">
                                            <div class="ml-auto">
                                                <span>
                                                    <b-btn variant="link" :to="{name: suggestedSubject, params: {subject: suggestedSubject, grade: grade, language: language}}" style="font-size: 14px;">
                                                        View {{suggestedSubjectName}}
                                                    </b-btn>
                                                </span>
                                                <b-btn
                                                    variant="success"
                                                    class="ml-1"
                                                    :disabled="addingBundleProductToCart"
                                                    @click.prevent="addProductToCart_BundleProduct"
                                                >
                                                    <span v-if="addingBundleProductToCart">
                                                        <font-awesome-icon :icon="['far', 'check']" /> {{suggestedSubjectName}} Added
                                                    </span>
                                                    <span v-else>
                                                        Add {{suggestedSubjectName}}
                                                    </span>
                                                </b-btn>
                                            </div>
                                        </div>
                                        <div class="d-flex">
                                            <div class="ml-auto">
                                                <span>
                                                    <b-btn variant="link" @click.prevent="setProductBundleDismissed" style="color:gray; text-decoration:underline;">
                                                        No Thanks
                                                    </b-btn>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </b-modal>

                            <!-- <div v-if="displayProductBundleOffer && !is_bundle_or_match_dismissed">

                                This is a popup that wants you to click on this button.
                                <a href="#" @click.prevent="addProductToCart_BundleProduct">add other product</a> <a href="#" @click.prevent="setProductBundleDismissed" >dismiss</a>
                            </div> -->
                        </div>
                    </div>
<!--                    <div v-if="canSwapSchools && isHomeschoolStore">Not a homeschool? Are you looking for the <a href="#school">District / School store</a>?</div>-->

                    <div v-if="(publications && publications.length) || (product && product.burrito)" ref="productBar" class="d-lg-none d-block bg-secondary fixed-bottom p-3 mobile-bar">
                        <div class="container">
                            <div class="row">
                                <div class="col-8 text-white align-self-center">
                                    <h5 class="m-0">{{product.title}}</h5>
                                </div>

                                <div class="col-4 align-self-center"><!--addingProductToCart-->
                                    <div class="d-flex">
                                        <button
                                            v-if="allowAddToCart == true"

                                            type="button"

                                            class="btn btn-success text-nowrap ml-auto"
                                            style="margin-bottom:60px;"

                                            @click.prevent="addProductToCart"

                                            :disabled="addingProductToCart || productWithDifferentFormatAlreadyInCart || allowAddToCart==false"
                                        >
                                            <template v-if="addingProductToCart">
                                                <font-awesome-icon :icon="['far', 'check']" /> Added
                                            </template>
                                            <template v-else>
                                                <font-awesome-icon :icon="['far', 'plus']" /> Add to Cart
                                            </template>
                                        </button>
                                        <!-- <router-link :to="{name: 'checkout'}" class="btn btn-light ml-2">
                                            <font-awesome-icon :icon="['fad', 'arrow-alt-from-left']" />
                                        </router-link> -->
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <br />
    </div>
</template>

<script>
import Vue from 'vue'

import { mapState, mapGetters } from 'vuex'

import product_formats from '@/common/product_formats'
// import product_prices from '@/common/product_prices'
import multiyear_options from '@/common/multiyear_options'
import states_disallow_discount_codes from '@/common/states_disallow_discount_codes'
import {publicationStates} from '@/common/states'

import Navbar from '@/components/Navbar'
import Footer from '@/components/Footer'
import {displaySku} from "@/common/utils";
import ProductCover from "@/components/products/ProductCover";
import ProductResources from "@/components/products/ProductResources";

export default {
    name: 'product',
    data: () => ({
        showSku: process.env.VUE_APP_ENV !== 'production',
        multiyear_options: multiyear_options,

        states_disallow_discount_codes: states_disallow_discount_codes,

        states: publicationStates,
        grades: ['0', '1', '2', '3', '4', '5', '6', '7', '8'],

        format: "print_online",
        selectedVersion: "free",

        productLanguage: null,
        quantity: 10,
        teachers: 1,
        type: "classroom",

        lang: null,

        addingProductToCart: false,
        addingBundleProductToCart: false,

        loading: false,

        allowAddToCart: true,

        limitQuantityForMultiyear: false,

        displayProductBundleOffer: false
    }),
    props: {
        'product': Object,
        'urlPath': String,
        'publications': Array,
        'state': String,
        'grade': [String,Number],
        'subject': String,
        'language': String,
        'version': String,
        'productDescription': String,
        'canSwapSchools': {
            type: Boolean,
            default: true,
        },
    },
    components: {
        ProductResources,
        ProductCover,
        Navbar,
        Footer
    },
    computed: {
        ...mapState({
            products: state => _.orderBy(state.cart.products, 'grade'),
            stateData: state => state.stateData.stateData,
            selectedState: state => state.stateData.selectedState,
            multiyear: state => state.cart.multiyear,
            bundle_dismissed_items: state => state.cart.bundle_dismissed_items
        }),
        ...mapGetters({isHomeschoolStore: 'isHomeschoolStore'}),
        freeVersion () {
            for(let p of this.stateData.publications) {
                if(p.sample_of_id == this.product.id)
                    return p
            }
            return false
        },
        multiyear_selected: {
            get () {
                if (this.multiyear)
                    return multiyear_options[this.multiyear-1];

                return multiyear_options[0]
            },
            set (multiyear_selected) {
                this.$store.commit('setMultiyearValue', multiyear_selected)
            }
        },
        selected_multiyear_value () {

            var selected_multiyear_value = 1

            if(!this.multiyear) {
                //this.multiyear = multiyear_options[0]
                this.$store.commit('setMultiyearValue', multiyear_options[0])

            }
            else {
                selected_multiyear_value = this.multiyear
            }

            return selected_multiyear_value
        },
        is_bundle_or_match_dismissed() {
            var status = false
            var bundle_status
            var matching_product
            var matching_product_status

            if(this.bundle_dismissed_items) {
                // //Get This Product Status
                bundle_status = this.bundle_dismissed_items[this.state + '-' + this.product.topic]

                // //Get Matching Status
                matching_product = this.getMatchingProduct(this.product.topic, this.grade, this.language)

                matching_product_status = this.bundle_dismissed_items[this.state + '-' + matching_product.topic]

                if(bundle_status == 1 || bundle_status == 2) {
                    status = true
                }

                if(matching_product_status == 1 || matching_product_status == 2) {
                    status = true
                }
            }

            return status
        },
        suggestedSubject() {
            if(this.subject == 'social-studies' || this.subject == 'national-social-studies') {
                return 'science'
            }
            if(this.subject == 'science') {
                // There should be a publication list in stateData.  Loop through to find if there's a
                // new social studies for this state/grade.  This is an example, I don't know the
                // actual data structure
                let subject = 'social-studies'
                for(let publication of this.stateData.publications) {
                    if(publication.topic == 'National Social Studies' && publication.grade == this.grade){
                        subject = 'national-social-studies'
                    }
                }
                return subject
            }
        },
        suggestedSubjectName() {
            if(this.suggestedSubject == 'science') { return 'Science' }
            return 'Social Studies'
        },
        product_formats () {
            if(!product_formats) return []

            if(this.product.availability == 'online'){
                return _.filter(product_formats, {value: 'online_only'})
            }
            if(this.product.availability == 'print'){
                return _.filter(product_formats, {value: 'print_online'})
            }
            if(this.product.availability == 'unavailable'){
                return []
            }

            return product_formats
        },
        groupedProducts () {
            return _.orderBy(this.product.grouped_products, ['product_group_order'],['asc'])
        },
        productCover () {
            if (this.product.cover_url) {
                return this.product.cover_url;
            }
            let productCover = null

            let sku = null

            if (this.product.sku) {
                let sku2 = this.product.sku.replace(/-(?:SS|SN)-(?:EN|ES)-V[0-9]{1,2}/, "")
                sku2 = sku2.replace(/V[0-9]{2}/, "")
                sku = this.product.sku.replace(/V[0-9]{2}/, "")

                productCover = 'store/products/sku/' + sku + '/OStore-' + sku2 + '-SE-Week1-Page1.jpg'
            }

            return productCover
        },
        formattedState () {
            let formattedState = null
            let searchState = (this.selectedState == 'NA') ? 'NA' : this.product.state;

            _.forEach(this.states, state => {
                if (searchState == state.state) {
                    formattedState = state.fullState
                }
            });

            return formattedState
        },
        formattedTopic () {
            let subject = null

            if (this.product.topic) {
                // remove hyphens from subject
                subject  = this.product.topic.replace(/-/g, " ")

                // title case subject
                subject = this.titleCase(subject)
                if(subject === "Well Being") subject = "Well-Being";
                if(subject === "Health Wellness") subject = "Health";
                if(subject === "health_wellness") subject = "Health";
                if (this.product.grade === -1) subject = "Other";
            }

            return subject
        },
        languages () {
            let languages = []

            // _.filter(this.stateData.publications, publication => {
            //     if (
            //         publication.language &&
            //         publication.topic == this.formattedTopic
            //     ) {
            //         languages.push(publication.language)
            //     }
            // })

            // only show language dropdown if publication with the selected grade has it available
            _.filter(this.stateData.publications, publication => {
                if (
                    publication.grade == this.grade &&
                    publication.subject == this.product.subject
                ) {
                    languages.push(publication.language)
                }
            })
            if (languages) {
                return _.uniq(languages)
            }
        },
        product_prices () {
            return this.product.prices
        },
        selected_format_product_prices () {
            if (
                this.format &&
                this.type &&
                this.product_prices
            ) {
                let option
                let format_prices = []

                for (option of this.multiyear_options) {

                    if (this.format == 'online_only') {
                        if (this.quantity > 9 && !this.isHomeschoolStore) {
                            if (this.product.prices[option.value]) {
                                format_prices[option.value] = {
                                    yearstotal: this.product.prices[option.value].online_only_yearstotal,
                                    singleprice: this.product.prices[option.value].online_only_singleprice
                                }
                            }
                        } else {
                            if(this.product.prices[option.value]) {
                                format_prices[option.value] = {
                                    yearstotal: this.product.prices[option.value].online_only_2_yearstotal,
                                    singleprice: this.product.prices[option.value].online_only_2_singleprice
                                }
                            }
                        }
                    }
                    else if (this.format == 'print_online') {
                        if(this.quantity > 9 && !this.isHomeschoolStore) {
                            if(this.product.prices[option.value]) {
                                format_prices[option.value] = {
                                    yearstotal: this.product.prices[option.value].print_online_yearstotal,
                                    singleprice: this.product.prices[option.value].print_online_singleprice
                                }
                            }
                        }
                        else {
                            if(this.product.prices[option.value]) {
                                format_prices[option.value] = {
                                    yearstotal: this.product.prices[option.value].print_online_2_yearstotal,
                                    singleprice: this.product.prices[option.value].print_online_2_singleprice
                                }
                            }
                        }
                    }
                }

                return format_prices
            }
        },
        price_online() {
            if (this.quantity >= 10 && !this.isHomeschoolStore)
                return this.product_prices[1].online_only_singleprice;
            return this.product_prices[1].online_only_2_singleprice;
        },
        set_price() {
            if (this.quantity >= 10 && !this.isHomeschoolStore)
                return this.product_prices[1].print_online_singleprice;
            return this.product_prices[1].print_online_2_singleprice;
        },
        price () {
            if (
                this.format &&
                this.type &&
                this.product_prices[this.selected_multiyear_value]
            ) {
                if (this.format == 'online_only') {
                    return this.product_prices[this.selected_multiyear_value].online_only_yearstotal
                }
                if (
                    this.type == 'classroom' &&
                    this.quantity >= 10
                ) {
                    return this.product_prices[this.selected_multiyear_value].print_online_yearstotal
                }
                if (
                    this.type == 'classroom' &&
                    this.quantity < 10
                ) {
                    return this.product_prices[this.selected_multiyear_value].print_online_2_yearstotal
                }
            }
        },
        price_single () {
            if(this.freeVersion && this.selectedVersion == 'free'){
                return 0;
            }
            if (
                this.format &&
                this.type &&
                this.product_prices[this.selected_multiyear_value]
            ) {
                if (this.format == 'online_only' && this.quantity >= 10 && !this.isHomeschoolStore) {
                    return this.product_prices[this.selected_multiyear_value].online_only_singleprice
                }
                if (this.format == 'online_only') {
                    return this.product_prices[this.selected_multiyear_value].online_only_2_singleprice
                }
                if (
                    this.type == 'classroom' &&
                    this.quantity >= 10 && !this.isHomeschoolStore
                ) {

                    return this.product_prices[this.selected_multiyear_value].print_online_singleprice
                }
                if (
                    this.type == 'classroom'
                ) {
                    return this.product_prices[this.selected_multiyear_value].print_online_2_singleprice
                }
            }
        },
        price_multiyear () {
            return this.price_single * this.selected_multiyear_value
        },
        price_best () {

            var option

            var best = {
                price: 10000000,
                year_amount: 1
            }

            for (option of multiyear_options) {
                if (this.format == 'online_only') {
                    if(this.product.prices[option.value].online_only_singleprice <= best.price) {
                        best.price = this.product_prices[option.value].online_only_singleprice
                        best.year_amount = this.product_prices[option.value].multi_years
                    }
                }
                else if (this.quantity >= 10) {
                    if(this.product.prices[option.value].print_online_singleprice <= best.price) {
                        best.price = this.product.prices[option.value].print_online_singleprice
                        best.year_amount = this.product_prices[option.value].multi_years
                    }
                }
                else if (this.quantity < 10) {
                    if(this.product.prices[option.value].print_online_2_singleprice <= best.price) {
                        best.price = this.product.prices[option.value].print_online_2_singleprice
                        best.year_amount = this.product_prices[option.value].multi_years
                    }
                }
            }

            return best
        },
        minQuantity () {
            let regex = /(HW-[0-9a-zA-Z]{2}-GE-(?:EN|ES)-V[0-9])|([a-zA-Z]{2}-[0-9a-zA-Z]{2}-HW-(?:EN|ES)-V[0-9])/;
            // console.log(this.product)
            // console.log(this.product.sku)
            let isHealthProduct = !this.product.sku.match(regex);
            if (this.isHomeschoolStore || this.product.topic == 'Character Education' || (this.product.topic == 'General Education' && !isHealthProduct))
                return 1;

            return 10
        },
        teacherOptions () {
            return ([...Array(Math.floor((this.quantity-1)/25)+1).keys()].map(x => parseInt(x)+1))
        },
        productWithDifferentFormatAlreadyInCart () {
            let productWithDifferentFormatAlreadyInCart = false
            _.filter(this.products, product => {
                if (
                    product.sku == this.product.sku &&
                    (product.format && product.format !== this.format)
                ) {
                    productWithDifferentFormatAlreadyInCart = true
                }
            })
            return productWithDifferentFormatAlreadyInCart
        },
        productWithNoPrice () {
            let productWithNoPrice = false
            if(this.price > 0) {
                //Price is Good
            }
            else {
                productWithNoPrice = true
            }
            return productWithNoPrice
        },
        showNYPromo() {
            // Date is bfore Jan. 30, 2026
            return !this.isHomeschoolStore && this.selectedState === 'NY' && new Date() < new Date('2026-01-30');
        } ,
    },
    watch: {
        'product': {
            handler (product) {
                // Should find new product? (user navigated to a route that isnt compatible with a product in this list. ex. routed to social-studies/9/en but there is no 9th grade)
                let shouldFetchNewProduct = (!product.sku);
                if (shouldFetchNewProduct && this.publications.length) {
                    // Try different language or grade
                    let firstItemsGrade = this.publications[0].grade;
                    let firstItemsLanguage = this.publications[0].language;
                    this.$router.push({
                        name: this.subject,
                        params: {
                            state: this.state,
                            grade: firstItemsGrade,
                            language: firstItemsLanguage,
                        },
                    })
                    return;
                }

                let grade = null

                _.forEach(this.publications, publication => {
                        grade = publication.grade
                })

                if (
                    this.language &&
                    !_.find(this.publications, {language: this.language})
                ) {
                    this.$router.push({
                        name: this.subject,
                        params: {
                            state: this.state,
                            grade: this.grade,
                            language: 'en',
                        },
                        query: {
                            preview: (this.$route.query.preview || 0)
                        }
                    })
                }

                this.setDefaults()

            },
            deep: true,
            immediate: true
        },
        'language': {
            handler (language) {
                if (language) {
                    this.lang = this.language
                    this.$store.commit('setLanguage', language)
                }
            },
            deep: true,
            immediate: true
        },
        'format': {
            handler (format) {
                if (format == 'online_only' && this.quantity < 10) {

                    //this.quantity = 10

                }
            },
            deep: true,
            immediate: true
        },
        'quantity': {
            handler (quantity) {
                this.checkIfValidQuantityForProduct()
            },
            deep: true,
            immediate: true
        },
        'selectedVersion': {
            handler (selectedVersion) {
                this.checkIfValidQuantityForProduct()
            },
            deep: true,
            immediate: true
        },
        // 'selected_multiyear_value': {
        //     handler (selected_multiyear_value) {
        //         if (selected_multiyear_value > 1 && this.quantity < 10) {
        //             this.quantity = 10

        //             this.allowAddToCart = true
        //         }
        //         else
        //         {
        //             this.allowAddToCart = false
        //         }
        //     },
        //     deep: true,
        //     immediate: true
        // },
        teacherOptions (teacherOptions) {
            if (teacherOptions) {
                let maxTeachers = Math.max.apply(Math, teacherOptions)

                this.teachers = maxTeachers
            }
        },
    },
    methods: {

        setDefaults () {
            if (this.product.burrito || this.isHomeschoolStore) {
                this.quantity = 1
            }
            if(this.product.discontinued == 1 || this.product.availability == 'online') {
                this.format = 'online_only'
            }else{
                this.format = 'print_online'
            }

            // TMP - move to a prop (default quantity / minimum quantity)
            if (this.product.topic == 'Character Education')
                this.quantity = 1;
        },
        buyNow() {
            this.addProductToCart();
            this.$nextTick(() => {
                this.$router.push('/cart');
            })
        },
        addProductToCart () {
            if (this.price == 0) {
                //Do Nothing

                this.$swal({
                    title: "Could not add item to cart",
                    html: "...",
                    type: 'error',
                })
            }
            else if (this.productWithDifferentFormatAlreadyInCart) {
                /*
                    If product is already in the cart with a different fromat and the button is not disabled for some reason,
                    prompt user that the product could not be added to the cart
                */
                this.$swal({
                    title: "Could not add item to cart",
                    html: "This product is already in your cart with a different format. Please first remove the conflicting item from the cart, or add more of the same format.",
                    type: 'error',
                })
            } else {
                /*
                    if product is not already in the cart (with a different format),
                    add product to cart
                */
                this.addingProductToCart = true

                setTimeout(() => {
                    this.addingProductToCart = false
                },1000)

                // console.log(this.freeVersion, this.product);

                let product;

                if (this.freeVersion && this.selectedVersion == 'free'){
                    product = _.cloneDeep(this.freeVersion)
                } else{
                    product = _.cloneDeep(this.product)
                }

                product.page_link = this.$route.path;

                if (this.quantity && !product.quantity || this.quantity != product.quantity) { this.$set(product, 'quantity', this.quantity) }

                if (this.grade || this.grade == '0') {
                    if (!product.cover) { this.$set(product, 'cover', this.productCover) }
                    if (!product.grade) { this.$set(product, 'grade', this.grade) }
                    if (this.type && !product.type) { this.$set(product, 'type', this.type) }
                    if (this.format) { this.$set(product, 'format', (this.freeVersion && this.selectedVersion == 'free' ? 'online_only' : this.format)) }
                    if (this.teachers && !product.teachers) { this.$set(product, 'teachers', this.teachers) }
                }

                //Burrito products don't have a title, but have a name.
                if (!product.title) { this.$set(product, 'title', product.name) }

                if (this.multiyear && this.selected_multiyear_value && !product.multiyear) {
                    this.$set(product, 'multiyear', this.selected_multiyear_value)
                }

                // if (this.type && !product.type) { this.$set(product, 'type', this.type) }
                // if (this.format && !product.format) { this.$set(product, 'format', this.format) }
                // if (this.teachers && !product.teachers) { this.$set(product, 'teachers', this.teachers) }

                this.$store.dispatch('addItem', product)

                let productsText = 'products'

                if (this.quantity < 1) {
                    productsText = 'product'
                }
                else {
                    productsText = 'products'
                }
                this.$forceUpdate();

                this.$swal({
                    toast: true,
                    html: this.quantity + ' ' + productsText + ' added to cart.',
                    type: 'success',
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 2500
                })

                if(this.quantity >= 10) {
                    this.doProductBundleOfferPopup()
                }


            }
        },
        getMatchingProduct(current_topic, current_grade, current_language) {
            let new_topic
            let new_bundle_publication
            let new_bundle_product = {}

            if(current_topic == 'Social Studies' || current_topic == 'National Social Studies') {
                new_topic = 'Science'
            }
            else {
                new_topic = 'Social Studies'
            }

            _.forEach(this.stateData.publications, publication => {
                if (publication.topic == new_topic && publication.grade == current_grade && publication.language == current_language) {
                    new_bundle_publication = publication
                }
            })

            new_bundle_publication.multiyear = this.multiyear_selected.value

            new_bundle_publication.quantity = this.quantity
            new_bundle_publication.format = this.format
            new_bundle_publication.type = this.type
            new_bundle_publication.teachers = this.teachers

            new_bundle_publication.cover = this.productCover_BundleProduct(new_bundle_publication.sku)

            return new_bundle_publication
        },
        addProductToCart_BundleProduct () {
            if (this.price == 0) {
                //Do Nothing

                this.$swal({
                    title: "Could not add item to cart",
                    html: "...",
                    type: 'error',
                })
            }
            else if (this.productWithDifferentFormatAlreadyInCart) {
                /*
                    If product is already in the cart with a different fromat and the button is not disabled for some reason,
                    prompt user that the product could not be added to the cart
                */
                this.$swal({
                    title: "Could not add item to cart",
                    html: "This product is already in your cart with a different format. Please first remove the conflicting item from the cart, or add more of the same format.",
                    type: 'error',
                })
            } else {
                /*
                    if product is not already in the cart (with a different format),
                    add product to cart
                */
                this.addingBundleProductToCart = true

                setTimeout(() => {
                    this.addingBundleProductToCart = false

                    this.$bvModal.hide('bundle-product-modal')
                },1000)

                // console.log(this.freeVersion, this.product);

                let bundle_product = _.cloneDeep(this.getMatchingProduct(this.product.topic, this.grade, this.language))

                bundle_product.page_link = this.$route.path;

                if (this.grade || this.grade == '0') {
                    // if (!bundle_product.cover) { this.$set(bundle_product, 'cover', this.productCover) }
                    // if (!bundle_product.grade) { this.$set(bundle_product, 'grade', this.grade) }
                    // if (this.type && !bundle_product.type) { this.$set(bundle_product, 'type', this.type) }
                    if (this.format && !bundle_product.format) { this.$set(bundle_product, 'format', (this.freeVersion && this.selectedVersion == 'free' ? 'online_only' : this.format)) }
                    // if (this.teachers && !bundle_product.teachers) { this.$set(bundle_product, 'teachers', this.teachers) }
                }

                //Burrito products don't have a title, but have a name.
                // if (!bundle_product.title) { this.$set(bundle_product, 'title', bundle_product.name) }

                // if (this.type && !bundle_product.type) { this.$set(bundle_product, 'type', this.type) }
                // if (this.format && !bundle_product.format) { this.$set(bundle_product, 'format', this.format) }
                // if (this.teachers && !bundle_product.teachers) { this.$set(bundle_product, 'teachers', this.teachers) }

                this.$store.dispatch('addItem', bundle_product)

                this.$swal({
                    toast: true,
                    html: bundle_product.quantity + ' products added to cart.',
                    type: 'success',
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 2500
                })

                this.setProductBundleAdded(this.product)
                this.setProductBundleAdded(bundle_product)
            }
        },
        doProductBundleOfferPopup() {
            if (this.isHomeschoolStore)
                return;


            if(!this.is_bundle_or_match_dismissed && this.isDiscountAllowedForCurrentState() == true) {
                if(this.product.topic == 'Social Studies' || this.product.topic == 'National Social Studies' || this.product.topic == 'Science') {
                    this.displayProductBundleOffer = true

                    this.$bvModal.show('bundle-product-modal')
                    this.$store.dispatch('bundleOffered', 'bundle2')
                }
            }
        },
        resetProductBundlePopup() {
            this.displayProductBundleOffer = false
        },
        // misc utility methods
        changeLanguage (language) {
            // console.log("changing language to: ", language);
            this.$store.commit('setLanguage', language);
            this.$router.push({
                name: this.subject,
                params: {
                    state: this.state,
                    grade: this.grade,
                    subject: this.subject,
                    language: language
                }
            })
        },
        titleCase (string) {
            let splitString = string.toLowerCase().split(' ')

            for (let i = 0; i < splitString.length; i++) {
                splitString[i] = splitString[i].charAt(0).toUpperCase() + splitString[i].substring(1)
            }

            return splitString.join(' ')
        },
        setProductBarPadding () {
            let height = null

            if (this.$refs.productBar) {
                height = this.$refs.productBar.clientHeight

                document.querySelector(".footer").setAttribute("Style", "padding-bottom:" + height + "px;");
            }
        },
        setProductBundleDismissedValue(value) {
            let bundle_product = _.cloneDeep(this.getMatchingProduct(this.product.topic, this.grade, this.language))

            let identifier = this.product.state + '-' + this.product.topic
            let bundle_identifier = this.product.state + '-' + bundle_product.topic

            //Dismiss This Product
            this.$store.commit('setProductBundleDismissed', {product_identifier:identifier, value:value})

            //Dismiss Other Product
            this.$store.commit('setProductBundleDismissed', {product_identifier:bundle_identifier, value:value})

            this.displayProductBundleOffer = false

            this.$nextTick(() => {
                //console.log(this.bundle_dismissed_items)
            })

            this.hideBundleDiscountModal()
        },
        setProductBundleAdded(this_product) {
            this.setProductBundleDismissedValue(2)
        },
        setProductBundleDismissed() {
            this.setProductBundleDismissedValue(1)
        },
        productCover_BundleProduct (sku) {
            let productCover = null

            if (sku) {
                let sku2 = this.product.sku.replace(/-(?:SS|SN)-EN-V[0-9]{1,2}/, "")
                sku2 = sku2.replace(/V[0-9]{2}/, "")
                sku = sku.replace(/V[0-9]{2}/, "")

                productCover = 'store/products/sku/' + sku + '/OStore-' + sku2 + '-SE-Week1-Page1.jpg'
            }

            return productCover
        },
        checkIfValidQuantityForProduct() {
            if(this.selected_multiyear_value > 1 && this.quantity < 10 && !this.product.burrito) {
                this.limitQuantityForMultiyear = true
            }
            else {
                this.limitQuantityForMultiyear = false
            }

            if (this.quantity < 10 && !this.product.burrito) {
                this.$store.commit('setMultiyearValue', multiyear_options[0])

                this.multiyear_options = [{
                    value: '1',
                    label: '1 Year Subscription'
                }]
            }
            else {
                this.multiyear_options = [...multiyear_options]
            }

            if (this.quantity < 10 && this.format == 'online_only') {
                // this.quantity = 10
                this.allowAddToCart = true
            }
            else if (this.quantity < 10 && this.selected_multiyear_value > 1 && !this.product.burrito) {
                // this.quantity = 10
                this.allowAddToCart = false
            }
                // else if (this.quantity < 10 && (this.product.topic == 'Well Being' || this.product.topic == 'Well-Being') && this.selectedVersion == 'full') {
                // this.allowAddToCart = false
            // }
            else
            {
                this.allowAddToCart = true
            }
        },
        hideBundleDiscountModal () {
            this.$bvModal.hide('bundle-product-modal')
        },
        resetProductBundleDismissedValues () {
            this.$store.commit('resetProductBundleDismissed')
        },
        isDiscountAllowedForCurrentState () {
             return (states_disallow_discount_codes.includes(this.state) != true)
        }
    },
    created() {
        this.$store.commit('setMultiyearValue', {
            value: 1,
            label: '1 Year Subscription'
        });
    },
    mounted () {
        // for (let i = 0; i < this.publications.length; i++) {
        //     console.log(this.publications[i].sku, this.publications[i].language)
        // }
        if (this.language) {
            this.productLanguage = this.language
        }



        //this.$store.commit('resetProductBundleDismissed')

        window.addEventListener('resize', this.setProductBarPadding)

        this.setProductBarPadding()

        this.setDefaults()

        window.scrollTo(0,0);
    }
}

</script>

<style lang="scss">

.callout-pin {
    position: absolute;
    color: red;
    width: 35px !important;
    height: 35px;
}

#image-modal .modal-body {
    padding: 0;
}

.bundle-discount-modal {
    .image-container {
        position: relative;
        margin: -150px -30px -150px -150px;
        img {
            height: 250px;
            width: auto;
        }
        .background-image {

        }
        .character-image {
            position: absolute;
            top: 0;
            left: 50%;
            transform: translateX(-50%);
        }
    }
    .text {
        width: 100%;
    }
}

@media (max-width: 991px) {
    .bundle-discount-modal {
        .image-container {
            margin: -150px -30px -150px -40px;
        }
    }
}

@media (max-width: 575px) {
    .bundle-discount-modal {
        .image-container {
            display: flex;
            justify-content: center;
            margin: 0 0 1rem;
        }
        .text {
            width: 100%;
        }
    }
}
</style>

<style lang="scss" scoped>
@import "@/assets/scss/_colors.scss";

.price > div {
    line-height: 1;
}

.nav-item {
    margin: .15rem;
}

.nav-link {
    border: 1px solid transparent;
    opacity: .33;
    color: #FFFFFF;
    font-size: 21px;
    padding: 5px 15px;
}

.nav-src:focus,
.nav-src:hover,
.nav-link.active {
    opacity: 1;
}

.nav-link.version {
    background-color: #563d7c;
    border-color: darken(#563d7c, 10%);
}
.nav-link.pre-k {
    background-color: $prek;
    border-color: darken($prek, 10%);
}

.nav-link.kindergarten {
    background-color: $kindergarten;
    border-color: darken($kindergarten, 10%);
}

.nav-link.first-grade {
    background-color: $first-grade;
    border-color: darken($first-grade, 10%);
}

.nav-link.second-grade {
    background-color: $second-grade;
    border-color: darken($second-grade, 10%);
}

.nav-link.third-grade {
    background-color: $third-grade;
    border-color: darken($third-grade, 10%);
}

.nav-link.fourth-grade {
    background-color: $fourth-grade;
    border-color: darken($fourth-grade, 10%);
    // color: darken($fourth-grade, 40%);
}

.nav-link.fifth-grade {
    background-color: $fifth-grade;
    border-color: darken($fifth-grade, 10%);
}

.nav-link.sixth-grade {
    background-color: $sixth-grade;
    border-color: darken($sixth-grade, 10%);
}

.nav-link.seventh-grade {
    background-color: $seventh-grade;
    border-color: darken($seventh-grade, 10%);
}

.nav-link.eighth-grade {
    background-color: $eighth-grade;
    border-color: darken($eighth-grade, 10%);
}

.nav-link.disabled {
    background-color: $muted;
    border-color: darken($muted, 10%);
    cursor: not-allowed;
    pointer-events: all;
}

.nav-link.disabled:focus,
.nav-link.disabled:active {
    outline: 0;
}

.selected-image {
    max-height: 600px;
    width: auto;
}


.product-placeholder-images .vue-content-placeholders {
    width: 75px;
    margin: 0 auto;
}

.product-placeholder-images .product-placeholder-image + .product-placeholder-image {
    margin-left: .5rem;
}

.product-placeholder-images .vue-content-placeholders-img {
    height: 100px;
}

.cover-image {
    max-height: 100%;

    flex: 1 1 auto;
    background: no-repeat center center / contain;
}

.cursor-pointer {
    cursor: pointer;
}

.mobile-bar {
    border-top: 1px solid darken($secondary, 10%);
}

.notAvailable {
    color: '#cccccc';
}

@media (max-width: 991px) {
    .cover-image {
        max-height: 500px;
    }
}

.swal-title {
    margin: 0px;
    font-size: 25px;
    box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.21);
    margin-bottom: 28px;
}

.loader {
    border: 16px solid #f3f3f3;
    border-radius: 50%;
    border-top: 16px solid #3498db;
    width: 120px;
    height: 120px;
    -webkit-animation: spin 2s linear infinite; /* Safari */
    animation: spin 2s linear infinite;
}
@-webkit-keyframes spin {
    0% { -webkit-transform: rotate(0deg); }
    100% { -webkit-transform: rotate(360deg); }
}

@keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
}
</style>
